import React from "react";
// SAIDI Report

// Default
import { useState, useEffect } from "react";

// Mui
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

// Custom
import Layout from "../../layout";
import ContainedButton from "../../forms/button/ContainedButton";
import CustomDataTable from "../../components/table/CustomTable";
import DatePickerInput from "../../forms/input/DatePickerInput";
import SaidiReportLineChart from "../charts/SaidiReportLineChart";

const SaidiReport: React.FC = () => {
  const [reportData, setReportData] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const generateMockData = () => {
    const data = [];
    for (let i = 1; i <= 12; i++) {
      const totalDuration = Math.floor(Math.random() * 1000);
      const numConsumers = 5000 + Math.floor(Math.random() * 5000);
      data.push({
        month: `Month ${i}`,
        totalDuration,
        numConsumers,
        saidi: (totalDuration / numConsumers).toFixed(2),
      });
    }
    return data;
  };

  useEffect(() => {
    setReportData(generateMockData());
  }, []);

  const COLUMNS = [
    "Month",
    "Total Duration of Interruptions (minutes)",
    "Number of Consumers Served",
    "SAIDI (minutes)",
  ];

  const rowsContent = reportData?.map((item, index) => (
    <TableRow
      key={index}
      sx={{
        height: "50px",
        background: (index + 1) % 2 ? "#F9FCFE" : "transparent",
      }}
      className="custom_table_tbody"
    >
      <TableCell>
        <Typography className="custom_table_tbody_cell">
          {item.month}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography className="custom_table_tbody_cell">
          {item.totalDuration}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography className="custom_table_tbody_cell">
          {item.numConsumers}
        </Typography>
      </TableCell>

      <TableCell>
        <Typography className="custom_table_tbody_cell">
          {item.saidi}
        </Typography>
      </TableCell>
    </TableRow>
  ));

  return (
    <Layout>
      <Card className="meters_title_card">
        <Typography variant="h5">SAIDI Report</Typography>
      </Card>

      <Card sx={{ mt: "20px", maxHeight: "400px" }}>
        <CardHeader
          title={
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Typography variant="h5">SAIDI Report</Typography>
              <Stack direction={"row"} gap={"20px"} alignItems={"center"}>
                <DatePickerInput
                  placeholder={"dd/mm/yyyy"}
                  width={"fit-content"}
                />
                <DatePickerInput
                  placeholder={"dd/mm/yyyy"}
                  width={"fit-content"}
                />
                <ContainedButton
                  label={"Apply Filters"}
                  sx={{
                    width: "fit-content",
                    height: "42px",
                    mt: "10px",
                    color: "#ffffff",
                  }}
                />
              </Stack>
            </Stack>
          }
        />
        <Divider />

        <CardContent>
          <SaidiReportLineChart reportData={reportData} />
        </CardContent>
      </Card>

      <Card sx={{ mt: "20px" }}>
        <CardHeader
          title={<Typography variant="h5">SAIDI Report Details</Typography>}
        />
        <Divider />

        <CardContent>
          <CustomDataTable
            sx={{ maxHeight: "600px" }}
            columns={COLUMNS}
            pagination={true}
            rowsContent={rowsContent}
            Actions={true}
            onPageChange={(_, newPage) => setPage(newPage)}
            rowsPerPage={rowsPerPage}
            page={page}
            onRowsPerPageChange={handleChangeRowsPerPage}
            totalCount={reportData?.length}
          />
        </CardContent>
      </Card>
    </Layout>
  );
};

export default SaidiReport;
